var React = require('react');

function Failed (props) {
    return React.createElement("svg",props,React.createElement("rect",{"y":"6","width":"8","height":"8","rx":"1","transform":"translate(0 -6)","fill":"#C11D17","fillRule":"evenodd"}));
}

Failed.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8"};

module.exports = Failed;

Failed.default = Failed;
